import React, { useContext } from "react";
import DocumentsReportTable from "../../../../containers/DocumentsReport/DocumentsReportTable";

import { FT_CDR } from "../../../../utils/constants/filter-tables-constants";
import { DOCUMENTS_REPORTS } from "../../../../utils/constants/constants";

import { ComplianceDocumentsContext } from "../ComplianceDocuments";
import useAuthorization from "src/custom-hooks/useAuthorization/useAuthorization";
import { AUTHORIZATIONS } from "src/utils/constants/authorization-constants";
import { useTranslation } from "react-i18next";

export interface Props {
  allowAuthorizations?: string[] | null;
  authDomainToHideDoc?: string | null;
  authDomainToSetVerified?: string | null;
}

const FiscalYearCompliance = ({ allowAuthorizations, authDomainToSetVerified, authDomainToHideDoc }: Props) => {
  const tRP = "pages.document_reports.compliance_documents.fiscal_year_compliance";
  const { t } = useTranslation();
  const {
    legalEntity: { legalEntityOption, selectedLegalEntity, legalEntityQuickFilter },
    year: { yearValue, yearPicker },
  } = useContext(ComplianceDocumentsContext);

  const hasAccessToComplianceDocuments = useAuthorization([
    AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
    AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  ]);

  return (
    <>
      {hasAccessToComplianceDocuments && (
        <DocumentsReportTable
          filter={FT_CDR}
          documentReportId={DOCUMENTS_REPORTS.COMPLIANCE_REPORT_ID}
          allReportsAlwaysOn={true}
          authDomainToHideDoc={authDomainToHideDoc}
          authDomainToSetVerified={authDomainToSetVerified}
          allowAuthorizations={allowAuthorizations}
          legalEntityFilter={{ legalEntityOption, selectedLegalEntity }}
          year={yearValue}
          quickFilters={
            <>
              {legalEntityQuickFilter && legalEntityQuickFilter}
              {yearPicker && yearPicker}
            </>
          }
          tableTitle={`${t(`${tRP}.tab_label`)}`}
        />
      )}
    </>
  );
};

export default FiscalYearCompliance;
